import { defineStore } from 'pinia';
import { ref } from 'vue';
import { ticketApi } from '@/services/ticketApi';

/**
 * Contagem de chamados NOVOS para o badge do menu "Ticket" (gestor/agentes da entidade).
 * Poller singleton: o NavCollapse do item Ticket chama start() ao montar; refresh() pode
 * ser disparado após ações (abrir/atender chamado) para atualizar na hora.
 * No master com Central do Grupo habilitada, o contador soma os tenants filhos.
 */
export const useTicketBadgeStore = defineStore('ticketBadge', () => {
  const count = ref(0);
  let timer: ReturnType<typeof setInterval> | null = null;
  // Capability resolvida uma vez por sessão de página (best-effort).
  let groupParams: Record<string, unknown> | null = null;

  async function resolveGroupParams(): Promise<Record<string, unknown>> {
    if (groupParams !== null) return groupParams;
    try {
      const cap = await ticketApi.groupScope();
      groupParams = cap.enabled ? { scope_group: 1 } : {};
    } catch {
      groupParams = {};
    }
    return groupParams;
  }

  async function refresh() {
    try {
      const extra = await resolveGroupParams();
      const { count: c } = await ticketApi.newCount(extra);
      count.value = Number(c) || 0;
    } catch {
      /* silencioso — badge é best-effort */
    }
  }

  function start(intervalMs = 60000) {
    void refresh();
    if (timer) return; // já rodando (singleton)
    timer = setInterval(refresh, intervalMs);
  }

  function stop() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  return { count, refresh, start, stop };
});

export default useTicketBadgeStore;
